import React from 'react'
import { graphql } from "@apollo/client/react/hoc";
import { compose } from 'recompose';
import { gql } from '@apollo/client'

class FormContainer extends React.Component {
  state = {
    errors: [],
    sent: false,
    error: null,
    loading: false
  }

  render() {
    const { loading, form, error } = this.props

    if (loading) return null
    if (error) return <p>An unexpected error has occured</p>

    return this.props.render(form)
  }
}

FormContainer.defaultProps = {
  formId: null
}

const FORM_QUERY = gql`
  fragment FormParts on Fields {
    label
    placeholder
    description
    id
    type
    className
    required
    validate
    options {
      label
      value
    }
    conditional
    conditionalLogic {
      actionType
      logic {
        field
        match
        value
      }
    }
  }
  query getForm($formId: String!) {
    form(id: $formId) {
      id
      title
      description
      submission
      buttonLabel
      confirmation {
        type
        label
        to
      }
      stateManage
      fields {
        ...FormParts
        fields {
          ...FormParts
        }
      }
    }
  }
`

const withForm = graphql(FORM_QUERY, {
  options: props => {
    return {
      variables: {
        formId: props.formId
      }
    }
  },
  props: ({ data, post }) => ({ ...data })
})

export default compose(withForm)(FormContainer)
